import { render, staticRenderFns } from "./tab-contents.vue?vue&type=template&id=9ef91f84&"
import script from "./tab-contents.vue?vue&type=script&lang=js&"
export * from "./tab-contents.vue?vue&type=script&lang=js&"
import style0 from "./tab-contents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports